import { mapGetters } from "vuex";
import CurrencyFormatter from "currency-formatter";
import options from "@/options";
import Numbers from "@/services/Numbers";

export default {
  computed: {
    ...mapGetters({
      currency: "settings/currency",
    }),
  },
  methods: {
    formatMoney(amount, currency = null) {
      return Numbers.formatMoney(amount, currency ? currency : this.currency);
    },
    formatNumber(number, useGrouping = true, minimumFractionDigits = 0) {
      if (!number) {
        return 0;
      }

      const formatted = new Intl.NumberFormat("en-US", {
        style: "decimal",
        useGrouping,
        maximumFractionDigits: 8,
        minimumFractionDigits,
      }).format(parseFloat(number));

      return formatted;
    },

    getCurrencyNameBySymbol(symbol) {
      if (!symbol) {
        return null;
      }
      const currency = options.currencies.find((c) => c.symbol === symbol);
      return currency ? currency.label : null;
    },

    getCurrencyCodeBySymbol(symbol) {
      return symbol === "ETH"
        ? "ETH"
        : CurrencyFormatter.findCurrency(symbol).code;
    },
  },
  filters: {
    toLocaleDateString: function (value) {
      if (!value) return '-';
      return (new Date(value)).toLocaleDateString();
    },
  },
};
